import React from 'react';
import './TrainingTimer.css';

const formatTime = (seconds) => {
    const safe = Math.max(0, Math.floor(seconds || 0));
    const m = Math.floor(safe / 60);
    const s = safe % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
};

const TrainingTimer = ({ secondsLeft, label }) => {
    if (secondsLeft == null) return null;

    const isLow = secondsLeft < 60;

    return (
        <div className={`timer ${isLow ? 'timer_low' : ''}`}>
            <div className="timer__hourglass" aria-hidden="true">
                <div className="timer__glass timer__glass_top" />
                <div className="timer__glass timer__glass_bottom" />
                <div className="timer__sand" />
            </div>
            <div className="timer__content">
                <span className="timer__label">{label || 'Осталось'}</span>
                <span className="timer__value">{formatTime(secondsLeft)}</span>
            </div>
        </div>
    );
};

export default TrainingTimer;